import React, { FunctionComponent, ReactNode, useMemo, useReducer } from "react";
import NotificationsContext from "@Contexts/NotificationsContext";
import { InitialNotificationsState, notificationsReducer } from "@States/notifications";

interface Props {
  children: ReactNode;
}

const NotificationsStateProvider: FunctionComponent<Props> = ({ children }) => {
  const initialNotifications: InitialNotificationsState = {
    notifications: [],
  };

  const [notifications, dispatchNotification] = useReducer(
    notificationsReducer,
    initialNotifications
  );

  const notificationsContext = useMemo(
    () => ({
      dispatchNotification,
      ...notifications,
    }),
    [notifications, dispatchNotification]
  );

  return (
    <NotificationsContext.Provider value={notificationsContext}>
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsStateProvider;
